const thumbnailImages = document.querySelectorAll('#thumbnailContainer-wrap img');
thumbnailImages.forEach( ( image ) => {
    image.addEventListener('mouseover', () => {
        const displayImage = document.querySelector('#displayContainer img');
        displayImage.setAttribute('src', image.src);

        const parentElement = image.parentElement;
        const imageCaption = parentElement.dataset.caption;
       
        const captionDiv = document.querySelector('#displayContainer .caption');
        
        captionDiv.innerHTML = imageCaption;
     
            
    })

})


 